const clone = (value) => JSON.parse(JSON.stringify(value));

const removeUndefinedFields = (item) =>
    Object.keys(item).reduce((result, key) => {
        if (item[key] !== undefined) {
            result[key] = item[key];
        }
        return result;
    }, {});

export const mergeListItem = (currentItem, updatedItem) => {
    if (!updatedItem || updatedItem.id == null) return null;

    return clone({
        ...currentItem,
        ...removeUndefinedFields(updatedItem),
    });
};
